import { ComponentVersions_3_0 } from 'constants/uxVersions'
import { Button, ComponentVersionsInherit, Dialog, DialogActions, DialogContent, DialogTitle } from 'opensolar-ui'
import { useEffect, useState } from 'react'
import { useTranslate } from 'react-admin'
import { useSelector } from 'react-redux'
import { imagerySelectors } from 'reducer/designer/detectImagery'
import { Z_INDEX_CONFIGS } from 'Themes'

export default function CustomImageryDialog() {
  const [isOpen, setIsOpen] = useState(false)
  const [isListeningToEditor, setisListeningtoEditor] = useState(false)
  const [imageRaw, setImageRaw] = useState<HTMLImageElement | null>(null)
  const [imageDataURL, setImageDataURL] = useState('')
  const [isInManualMode, setIsInManualMode] = useState(false)
  const translate = useTranslate()
  const availableImages = useSelector(imagerySelectors.getAvailableImageryTypes)

  const switchToManualMode = () => {
    const manualMode = availableImages.find((image) => image.design_mode === 'Manual' && image.map_type === 'None')
    if (!manualMode) {
      console.error('No manual mode found')
      return false
    }

    const commandUUID = window.Utils.generateCommandUUIDOrUseGlobal()
    const startLocation4326 = window.AccountHelper.sceneOrigin4326FromSceneOrProject()

    const viewInstantiation = window.SceneHelper.viewForMapTypeData(manualMode, { center: startLocation4326 })
    window.editor.execute(new AddViewCommand(viewInstantiation, window.ViewHelper, true, undefined, commandUUID))

    return true
  }
  useEffect(() => {
    if (!isListeningToEditor && window.editor) {
      window.editor.signals.customImageryUploaded.add(onImageDrop)
      setisListeningtoEditor(true)
    }
  }, [])

  const onImageDrop = (image: HTMLImageElement, imageDataURL: string, isInManualMode: boolean) => {
    setImageRaw(image)
    setImageDataURL(imageDataURL)
    setIsInManualMode(isInManualMode)
    setIsOpen(true)
  }

  const handleOptionSelect = (selection: string) => {
    switch (selection) {
      case '3D': {
        if (!isInManualMode) {
          if (!switchToManualMode()) return
        }
        window.SceneHelper.setCustomImageAsGround(imageRaw as HTMLImageElement, imageDataURL)
        break
      }
      default: {
        discardImage()
        break
      }
    }
    setIsOpen(false)
  }

  const handleClose = () => {
    discardImage()
    setIsOpen(false)
  }

  const discardImage = () => {
    setImageRaw(null)
    setImageDataURL('')
  }

  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ zIndex: Z_INDEX_CONFIGS.modal }}
      >
        <DialogTitle id="alert-dialog-title">{translate('Custom Imagery Upload')}</DialogTitle>
        <DialogContent>
          <img src={imageDataURL} alt="Custom Imagery" style={{ width: '100%', height: 'auto' }} />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="inherit" onClick={() => handleOptionSelect('')}>
            {translate('Cancel')}
          </Button>
          <Button variant="contained" color="primary" onClick={() => handleOptionSelect('3D')}>
            {translate(isInManualMode ? 'Upload' : 'Upload & Add Manual View')}
          </Button>
        </DialogActions>
      </Dialog>
    </ComponentVersionsInherit>
  )
}
